import React from "react";
import { inject, observer } from "mobx-react";
import { observable } from "mobx";

import { IManagementStore } from "Stores/Management/types";
import PermissionsContent from "./PermissionsContent/PermissionsContent";
import { Values } from "@src/Tools/Values";
import { IApplicationsStore } from "../../../../../Stores/Applications/types";

interface IProps {
  management?: IManagementStore;
  applicationsStore?: IApplicationsStore;
}

@inject("management", "applicationsStore")
@observer
class ManagePermissions extends React.Component<IProps> {
  @observable isLoading: boolean = true;

  async componentDidMount() {
    try {
      await this.props.management.getPermissions();
      await this.props.applicationsStore.getApplicationsUserRoles();
      this.isLoading = false;
      document.title = Values.getLocalizationValue("permissions");
    } catch (error) {
      console.error(error);
    }
  }
  render() {
    return <div>{this.isLoading ? <div /> : <PermissionsContent />}</div>;
  }
}

export default ManagePermissions;
